export const APLICATIVOS = {
  CANCELACIONES: 'CANCELACIONES',
  RENOVACIONES: 'RENOVACIONES',
  ENDOSOS: 'ENDOSOS',
};
